<div class="dashboard-content-sec ">
  <div class="loader" *ngIf="btnText == 'Replying...'">
    <img src="assets/images/loader.gif" alt="">
  </div>
 <form [formGroup]="form" (ngSubmit)="updateForm()">
 <div class="form-section">
   <div class="mr-auto col-md-3 mb-4" *ngIf="curr_user_id.RoleType === 6">
     <div class="card sidecard">
       <div class="card-form">

         <div class="form-row">
           <div class="form-group col-md-12">
             <label for="assignedTo">Assigned To </label>
               <select formControlName="assignedTo" name="assignedTo" id="assignedTo" class="form-control">
                 <option id="{{assign_user.UserID}}" value="{{assign_user.UserID}}" 
                        *ngFor="let assign_user of assignedUser">{{assign_user?.FirstName}} {{assign_user?.LastName}}
                 </option>
               </select>
           </div>
         </div>

         <div class="form-row">
           <div class="form-group col-md-12">
             <label for="assignedTo">Client</label>
               <select formControlName="clientId" name="clientId" (change)="getRequester($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }">
                 <option value="" *ngIf="clientMissing">Unknown client</option>
                 <option id="{{client.ID}}" value="{{client.ID}}" *ngFor="let client of clients">{{client.ClientName}}</option>
               </select>
           </div>
         </div>

         <div class="form-row">
           <div class="form-group col-md-12">
             <label for="requestor">Requestor </label>
               <select formControlName="userID" name="userID" id="requestor" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.userID.errors }">
                 <option value="" *ngIf="requesterMissing">Former user</option>
                 <option value="{{requesterUserId}}" *ngIf="!requesterMissing && clientMissing">{{requesterFullName || 'Former user'}}</option>
                 <option value="{{usr.UserID}}" *ngFor="let usr of CCemailList">{{usr?.FirstName}} {{usr?.LastName}}</option>
               </select>
           </div>
         </div>

         <div class="form-row">
           <div class="form-group col-md-12">
             <label for="ticketStatus">Ticket Status</label>
               <select formControlName="statusId" name="statusId" id="ticketStatus" class="form-control">
                 <option value="" disabled>Select Status</option>
                 <option value="1">New</option>
                 <option value="2">Active</option>
                 <option value="3">Closed</option>
               </select>
           </div>
         </div>

         <div class="form-row">
           <div class="form-group col-md-12">
             <label for="keyword">Keywords</label>

             <ng-multiselect-dropdown
               [placeholder]="'Select Keywords'"
               [data]="dropdownList"
               formControlName="keyword" name="keyword" id="keyword"
               [settings]="dropdownSettings"
             >
            </ng-multiselect-dropdown>

           </div>
         </div>

         <div class="form-row" style="margin-top:15px;">
           <div class="form-group col-md-12">
             <label for="keyword">Agent CC</label>
             <ng-multiselect-dropdown
               [placeholder]="'Select'"
               [data]="agentCCemailList"
               formControlName="agentCC" name="agentCC" id="agentCC"
               [(ngModel)]="agentCCSelected"
               [settings]="CCdropdownSettings"
               >
             </ng-multiselect-dropdown>
           </div>
         </div>

       </div>
     </div>
   </div>




   <div class="col">

     <div class="card" >

        <div class="card-title">
          <div class="float-right text-danger">{{serviceList}}</div>
          <div class="float-left" style="width: 100%"> 
            <!-- row d-flex no-gutters"> -->
            <div class="">
              <h3><span class="icon-bg"><img src="assets/images/ticket-icon.svg" alt="ticket Icon"></span> {{subject}} (#{{ticket}})</h3>
              <p>{{created_at | date:'MM/dd/yyyy hh:mma'}} | {{useremail}} 
                  <span *ngIf="curr_user_id.RoleType === 6"> | </span> 
                  <a *ngIf="curr_user_id.RoleType===6" href="javascript:void(0)" (click)="openModal(content,'opens')">Company Profile</a> 
              </p>             
            </div>
          </div>       
          

          <div id="createTick" class="float-right" *ngIf="form.value.statusId===3">
            <a href="javascript:void(0)" (click)="reopenTicket()" >
                ReOpen Ticket
            </a>
        </div>
        
        </div>
       
        <div class="card-form">

          <div class="form-row">
              <label class="col-sm-2">Subject Line</label>
              <div class="form-group col-sm-4">
                  <input formControlName="ticketSubject"  id="ticketSubject"
                      name="ticketSubject" type="text" 
                      required 
                      class="form-control" 
                      tabindex="1" placeholder="">
               </div>
          </div>
          <!-- <div *ngIf="CompanyNameCtrl.invalid && (CompanyNameCtrl.dirty || CompanyNameCtrl.touched)"
               class="invalid-feedback">
              <div *ngIf="CompanyNameCtrl.errors.required">
                  <span>Client Name is required.</span>
              </div>
              <div *ngIf="CompanyNameCtrl.errors.minlength">
                  Client Name must be at least 2 characters long.
              </div>
          </div>           -->

            <div class="form-row">
                <label class='col-sm-2'>Subject Matter</label>
                <div class='form-group col-sm-4'>
                    <select formControlName="ticketSubjectMatter" name="ticketSubjectMatter" tabindes="2"
                            class="form-control" [ngClass]="{ 'is-invalid': submitted && f.ticketSubjectMatter.errors }">
                      <option value="" *ngIf="subjectMatterMissing"></option>
                      <option value="{{sub.ID}}" *ngFor="let sub of subjects">{{sub?.Value}}</option>
                    </select>
                </div>
            </div>

            <div id="conflict" class="mt-1 form-row collapse" >
              <label class="col-sm-2 control-label">Employee(s) & Locale</label>
              <div class="card col d-flex pl-3" style="margin-left: 5px !important;">
         
                  <table id="empTable" class="table-md">
                      <thead>
                          <tr>
                              <th scope="col">Name</th>
                              <th scope="col">City</th>
                              <th scope="col">State</th >
                          </tr>
                      </thead>
      
                      <tbody>
                          <ng-container *ngFor="let emp of empTable">
                              <tr id="state-row{{emp.ID}}" class="mb-3">
                                <td class="pr-1 pb-1">
                                  {{emp.empName}}
                                </td>

                                <td class="pr-1 pb-1">
                                  {{emp.empCity}}
                                </td>

                                <td class="pr-1 pb-1">
                                  {{emp.empState}}
                                </td>
                              </tr>
                          </ng-container>
                      </tbody>       
                  </table>
              </div>
          </div>


            <div class="form-row mb-3">
                <label class="col-sm-2">CC</label>
                <div class="form-group col-sm-4">
                    <ng-multiselect-dropdown tablindex="4"
                        [placeholder]="'Select'"  [data]="CCemailList"
                        formControlName="clientCC" name="clientCC" id="clientCC"
                        [settings]="CCdropdownSettings" [(ngModel)]="clientCCSelected">
                    </ng-multiselect-dropdown>
                </div>
           </div>

           <div class="form-row mb-10">
             <div class="form-group col-sm-12">
                <div class="form-tab-group" *ngIf="curr_user_id.RoleType === 6">
                    <label for="reply" (click)="changeType(1)" [ngClass]="(type==1)?'active':''">Reply</label>
                    <label  for="internal-note" [ngClass]="(type==2)?'active':''" (click)="changeType(2)">Internal Note</label>
                </div>
                <div [ngClass]="(type==1)?'form-row textarea':'form-row textarea yellow'" style="border: none">
                    <div class="errorHandler custom-upload mb-2" style="padding: 5px;">
                      <div id="response" [froalaEditor]="options" [(froalaModel)]="replyContent"></div>
                    </div>
                </div>
             </div>
           </div>

            <div class="form-row mb-10">
              <label>Attach files. Use Ctrl+click to select multiple files.</label>
            </div>
            <div class="form-row">
                <!-- <input name="fileInput" class="filestyle btn btn-default btn-outline-primary" 
                  (change)="getFiles($event)" type="file" multiple
                  data-buttonText="hellow" /> -->
                
                <input type="button" class="btn btn-default" value="Choose File(s)" onclick="document.getElementById('file').click();" />
                <input type="file" style="display:none;" id="file" 
                       (change)="getFiles($event)"                       
                       name="file" multiple/>
            </div>
            <div>
              <span>{{custom_image_title}}</span>
                <!-- <button type="button" class="btn btn-default btn-outline-primary align-items-end">Choose File</button><span>{{custom_image_title}}</span> -->
            </div>
            <div class="upload-error" role="alert" *ngIf="fileErrors.length > 0">
              <span *ngFor="let msg of fileErrors">{{msg}}</span>
            </div>


                  <!-- <ngb-tabset>
                     <ngb-tab>
                        <ng-template ngbTabTitle><i class="fa fa-text-height" tabindex="5"></i></ng-template>
                        <ng-template ngbTabContent>
                            <div id="response" ></div>                           
                        </ng-template>                        
                     </ngb-tab>

                     <ngb-tab>
                        <ng-template ngbTabTitle><i class="fa fa-paperclip" tabindex="6"></i></ng-template>
                        <ng-template ngbTabContent>
                            <input name="fileInput" (change)="getFiles($event)" type="file" multiple />
                            <button type="button" class="btn btn-default btn-outline-primary align-items-end">Choose File</button><span>{{custom_image_title}}</span>
                        </ng-template>
                     </ngb-tab>
                   </ngb-tabset> -->
                 <!-- </div>

               </div>
             </div>
           </div> -->

           <div class="upload-error" role="alert" *ngIf="submitError">{{submitError}}</div>
           <button type="submit" class="btn btn-default btn-outline-primary align-items-end" 
                tabindex="7">{{btnText}}
           </button>

       </div>
       <div class="tc">
         <span class="">*By clicking submit, you agree to the 
           <a class="tc-a" target="_blank" href="https://myhrcounsel.com/terms/">Terms and Conditions</a>
         </span>
       </div>
  
       <!-- Comment Section-->

       <div class="card-title mt-2">
         <!-- 
        <ngb-tabset class="reply-section">
           <ngb-tab id="tab-selectbyid1">
         -->

         <nav ngbNav #nav="ngbNav" class="nav-tabs">
          <ng-container ngbNavItem>
            <a ngbNavLink><h3>Conversations</h3></a>
<!--
             <ng-template ngbTabTitle><h3> Conversations</h3></ng-template>
             <ng-template ngbTabContent>
             -->
             <ng-template ngbNavContent >
              <div class="chat-box">

                 <!-- clist.user can be null when the conversation's author was deleted
                      (orphan replied_by). Unguarded access threw mid-render, blanking
                      every bubble below and breaking the files tab. -->
                 <div *ngFor="let clist of conversation;" [ngClass]="clist.user?.RoleType===2 ? 'row align-items-start justify-content-start flex-column' : 'row align-items-end justify-content-end flex-column'">
                   <div [ngClass]="clist.user?.RoleType === 2 ? 'media d-flex' : 'media d-flex flex-row-reverse'"
                        class="conversation-bubble">

                     <span class="username">{{clist.user?.FirstName | slice:0:1}}{{clist.user?.LastName | slice:0:1}}</span>
                     <div class="media-body ml-auto" [ngClass]="clist.user?.RoleType!==2 ? 'pr-2' : ''">
                       <div class="user-info"><strong>{{clist.user?.FirstName || 'Former user'}}</strong>
                         <span>{{clist.created_at | date:'MM/dd/yyyy hh:mma'}}</span></div>
                       <div [ngClass]="(clist.type==1)?'media-content speech-bubble':'media-content speech-bubble yellow'" 
                        style="display: inline-block;width:100%;">
                         <p style="white-space: pre-wrap" [innerHTML]="clist.reply"></p>
                       </div>
                     </div>
                   </div>
                 </div>

               </div>

              </ng-template>
          </ng-container>
          
 
          <ng-container ngbNavItem>
            <a ngbNavLink><h3>Files</h3></a>
              <ng-template ngbNavContent>

               <div *ngFor="let flist of metaFiles;" class="row align-items-start justify-content-between no-gutters mt-4 mb-4 uploaded-files">
                 <div class="media d-flex">
                   <a href="javascript:void(0)" (click)="downloadFile(flist)"><img class="" src="assets/images/file.png" alt="Generic placeholder image"></a>
                   <div class="media-body ml-auto">
                     <div class="user-info">
                       <strong><a href="javascript:void(0)" (click)="downloadFile(flist)">{{flist.name}}</a></strong>
                       <span>{{flist.uploaded_at | date:'MM/dd/yyyy hh:mma'}}</span>
                      </div>
                   </div>
                 </div>
                 <a href="javascript:void(0)" (click)="downloadFile(flist)" class="btn download ">
                   <i class="fa fa-download"></i>
                 </a>
               </div>

              </ng-template>
          </ng-container>
          </nav>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
       </div>



     </div>

     <div class="card" *ngIf="isAccessManager">
       <div class="card-title">
         <h3>Restricted Attorney Access</h3>
       </div>
       <div class="card-form">

         <table class="table user-table table-striped" *ngIf="accessGrants?.length">
           <thead>
             <tr>
               <th>Name</th>
               <th>Email</th>
               <th>&nbsp;</th>
             </tr>
           </thead>
           <tbody>
             <tr *ngFor="let grant of accessGrants">
               <td>{{grant.first_name}} {{grant.last_name}}</td>
               <td>{{grant.email}}</td>
               <td>
                 <a title="Remove" class="btn fa fa-times" href="javascript:void(0)" (click)="removeAccess(grant)"></a>
               </td>
             </tr>
           </tbody>
         </table>
         <p *ngIf="!accessGrants?.length">No restricted attorneys have been granted access to this ticket.</p>

         <div class="form-row">
           <div class="form-group col-md-4">
             <label for="accessUser">Attorney</label>
             <select id="accessUser" name="accessUser" class="form-control"
                     [(ngModel)]="selectedEligibleUserId" [ngModelOptions]="{standalone: true}">
               <option value="">Select Attorney</option>
               <option *ngFor="let elig of eligibleToGrant" value="{{elig.user_id}}">{{elig.first_name}} {{elig.last_name}}</option>
             </select>
           </div>

           <div class="form-group col-md-6">
             <div class="form-check">
               <input class="form-check-input" type="radio" name="accessScope" id="accessScopeTicket"
                      value="ticket" [(ngModel)]="accessScope" [ngModelOptions]="{standalone: true}">
               <label class="form-check-label" for="accessScopeTicket">This ticket only</label>
             </div>
             <div class="form-check">
               <input class="form-check-input" type="radio" name="accessScope" id="accessScopeClient"
                      value="client" [(ngModel)]="accessScope" [ngModelOptions]="{standalone: true}">
               <label class="form-check-label" for="accessScopeClient">This ticket and all of this client's existing tickets</label>
             </div>
           </div>

           <div class="form-group col-md-2">
             <button type="button" class="btn btn-default" [disabled]="!selectedEligibleUserId" (click)="addAccess()">Add</button>
           </div>
         </div>

       </div>
     </div>

   </div>



 </div>


</form>
</div>


<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-body">
        <button aria-label="Close" class="close" (click)="closeModal()" type="button"><span aria-hidden="true">×</span></button>
        <form>
            <div class="form-row search-row info">
              <img *ngIf="avatar" class="align-self-center" src="assets/images/user.png" alt="Generic placeholder image">
              <img *ngIf="!avatar" class="align-self-center" src="assets/images/default-user.jpg" alt="Generic placeholder image">
                <ul>
                    <li>
                        <strong>Name:</strong>{{username}}
                    </li>
                    <li>
                        <strong>Email:</strong>{{useremail}}
                    </li>
                    <li>
                        <strong>Company Name:</strong>{{company_name}}
                    </li>
                </ul>
                <div class="company-info">
                    <h3>
                        Company Info
                    </h3>
                    <p *ngIf="company_info">
                      {{company_info}}
                    </p>
                    <p *ngIf="!company_info">
                      No Information Available
                    </p>
                </div>
            </div>
        </form>
    </div>
</ng-template>
